export default "__VITE_ASSET__C$VjLXq7__"